import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CourseCoupon} from '../models/coupon.model';
import {createReducer, on} from '@ngrx/store';
import {CouponActions} from './action-types';
import {Timestamp} from "@firebase/firestore";


export interface CouponsState extends EntityState<CourseCoupon> {

}

const toDate = (c: CourseCoupon) => {

  if (c.created?.toDate) {
    return c.created?.toDate()?.getTime()
  }

  return new Timestamp(c?.created?.seconds, c?.created?.nanoseconds)?.toDate()?.getTime();

}

export const adapter: EntityAdapter<CourseCoupon> = createEntityAdapter<CourseCoupon>({
  sortComparer: (c1, c2) => {

    return toDate(c2) - toDate(c1);

  }

});


export const initialCouponsState: CouponsState = adapter.getInitialState({

});


export const couponsReducer = createReducer(
  initialCouponsState,

  on(CouponActions.addCoupons, (state, {coupons}) => adapter.addMany(coupons, state)),

  on(
    CouponActions.addCoupon,
    CouponActions.loadCouponCompleted,
    (state, {coupon}) =>  adapter.addOne(coupon, state)
  ),

  on(
    CouponActions.updateCoupon,
    (state, {coupon}) => adapter.updateOne(coupon, state)
  ),

  on(CouponActions.deleteCouponSuccess, (state, {couponId}) => 
    adapter.removeOne(couponId, state)
  )

);


export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();



